import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneEventsActivitiesNextFlow = createAsyncThunk(
  "GetOneEventsActivitiesNextFlow/GetOneEventsActivitiesNextFlow",
  async (pR_EventsActivitiesNextFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/GetPR_EventsActivitiesNextFlowData",
        {
          pR_EventsActivitiesNextFlowGUID: pR_EventsActivitiesNextFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteEventsActivitiesNextFlow = createAsyncThunk(
  "DeleteEventsActivitiesNextFlow/DeleteEventsActivitiesNextFlow",
  async (pR_EventsActivitiesNextFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/DeletePR_EventsActivitiesNextFlowData",
        {
          pR_EventsActivitiesNextFlowGUID: pR_EventsActivitiesNextFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListEventsActivitiesNextFlow = createAsyncThunk(
  "GetListEventsActivitiesNextFlow/GetListEventsActivitiesNextFlow",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/GetPR_EventsActivitiesNextFlowListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateEventsActivitiesNextFlowData = createAsyncThunk(
  "UpdateEventsActivitiesNextFlowData/UpdateEventsActivitiesNextFlowData",
  async (EventsActivitiesNextFlowData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/UpdatePR_EventsActivitiesNextFlowData",
        {
          pR_EventsActivitiesNextFlowGUID:
            EventsActivitiesNextFlowData.pR_EventsActivitiesNextFlowGUID,
          activityName: EventsActivitiesNextFlowData.activityName,
          pR_NationalityId: EventsActivitiesNextFlowData.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesNextFlowData.pR_TypeOfActivityId,
          durationDays: EventsActivitiesNextFlowData.durationDays,
          activityStartDate: EventsActivitiesNextFlowData.activityStartDate,
          activityEndDate: EventsActivitiesNextFlowData.activityEndDate,
          pR_ReportsStagesGuid:
            EventsActivitiesNextFlowData.pR_ReportsStagesGuid,
          pR_AgeGroupID: EventsActivitiesNextFlowData.pR_AgeGroupID,
          pR_CityId: EventsActivitiesNextFlowData.pR_CityId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddEventsActivitiesNextFlowData = createAsyncThunk(
  "AddEventsActivitiesNextFlowData/AddEventsActivitiesNextFlowData",
  async (EventsActivitiesNextFlowData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/AddPR_EventsActivitiesNextFlowData",
        {
          activityName: EventsActivitiesNextFlowData.activityName,
          pR_NationalityId: EventsActivitiesNextFlowData.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesNextFlowData.pR_TypeOfActivityId,
          durationDays: EventsActivitiesNextFlowData.durationDays,
          activityStartDate: EventsActivitiesNextFlowData.activityStartDate,
          activityEndDate: EventsActivitiesNextFlowData.activityEndDate,
          pR_ReportsStagesGuid:
            EventsActivitiesNextFlowData.pR_ReportsStagesGuid,
          pR_AgeGroupID: EventsActivitiesNextFlowData.pR_AgeGroupID,
          pR_CityId: EventsActivitiesNextFlowData.pR_CityId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateEventsActivitiesNextFlow = createAsyncThunk(
  "ValidateEventsActivitiesNextFlow/ValidateEventsActivitiesNextFlow",
  async (EventsActivitiesNextFlowData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_EventsActivitiesNextFlow/ValidatePR_EventsActivitiesNextFlowData",
        {
          activityName: EventsActivitiesNextFlowData.activityName,
          pR_NationalityId: EventsActivitiesNextFlowData.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesNextFlowData.pR_TypeOfActivityId,
          durationDays: EventsActivitiesNextFlowData.durationDays,
          activityStartDate: EventsActivitiesNextFlowData.activityStartDate,
          activityEndDate: EventsActivitiesNextFlowData.activityEndDate,
          pR_AgeGroupID: EventsActivitiesNextFlowData.pR_AgeGroupID,
          pR_CityId: EventsActivitiesNextFlowData.pR_CityId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteEventsActivitiesNextFlow = createAsyncThunk(
  "GetSpecificRowNoteEventsActivitiesNextFlow/GetSpecificRowNoteEventsActivitiesNextFlow",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      // data = data.filter((item) => item.incrementNumber - 1 === 1);
      console.log(data, "koiuuhh");

      // return data.filter((item) => item.incrementNumber - 1 === 1);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const EventsActivitiesNextFlow = createSlice({
  name: "EventsActivitiesNextFlow",
  initialState: {
    OneEventsActivitiesNextFlow: {},
    loadingOneEventsActivitiesNextFlow: false,
    errorOneEventsActivitiesNextFlow: null,

    AddEventsActivitiesNextFlow: {},
    loadingAddEventsActivitiesNextFlow: false,
    errorAddEventsActivitiesNextFlow: null,

    UpdateEventsActivitiesNextFlow: {},
    loadingUpdateEventsActivitiesNextFlow: false,
    errorUpdateEventsActivitiesNextFlow: null,

    DeleteEventsActivitiesNextFlow: {},
    loadingDeleteEventsActivitiesNextFlow: false,
    errorDeleteEventsActivitiesNextFlow: null,

    ListEventsActivitiesNextFlow: {},
    loadingListEventsActivitiesNextFlow: false,
    errorListEventsActivitiesNextFlow: null,

    EventsActivitiesNextFlowValidate: [],
    loadingEventsActivitiesNextFlowValidate: false,
    errorEventsActivitiesNextFlowValidate: null,

    OneSpecificRowNoteEventsActivitiesNextFlow: {},
    loadingOneSpecificRowNoteEventsActivitiesNextFlow: false,
    errorOneSpecificRowNoteEventsActivitiesNextFlow: null,
  },
  reducers: {
    restValidateEventsActivitiesNextFlow: (state, action) => {
      state.EventsActivitiesNextFlowValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneEventsActivitiesNextFlow.pending, (state, action) => {
        state.loadingOneEventsActivitiesNextFlow = true;
        state.OneEventsActivitiesNextFlow = action.payload;
        state.errorOneEventsActivitiesNextFlow = null;
      })
      .addCase(GetOneEventsActivitiesNextFlow.fulfilled, (state, action) => {
        state.loadingOneEventsActivitiesNextFlow = false;
        state.OneEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneEventsActivitiesNextFlow.rejected, (state, action) => {
        state.loadingOneEventsActivitiesNextFlow = false;
        state.errorOneEventsActivitiesNextFlow = action.payload;
      })

      .addCase(DeleteEventsActivitiesNextFlow.pending, (state, action) => {
        state.loadingDeleteEventsActivitiesNextFlow = true;
        state.DeleteEventsActivitiesNextFlow = action.payload;
        state.errorDeleteEventsActivitiesNextFlow = null;
      })
      .addCase(DeleteEventsActivitiesNextFlow.fulfilled, (state, action) => {
        state.DeleteEventsActivitiesNextFlow = false;
        state.DeleteEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteEventsActivitiesNextFlow.rejected, (state, action) => {
        state.loadingDeleteEventsActivitiesNextFlow = false;
        state.errorDeleteEventsActivitiesNextFlow = action.payload;
      })
      .addCase(GetListEventsActivitiesNextFlow.pending, (state, action) => {
        state.loadingListEventsActivitiesNextFlow = true;
        state.ListEventsActivitiesNextFlow = action.payload;
        state.errorListEventsActivitiesNextFlow = null;
      })
      .addCase(GetListEventsActivitiesNextFlow.fulfilled, (state, action) => {
        state.loadingListEventsActivitiesNextFlow = false;
        state.ListEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListEventsActivitiesNextFlow.rejected, (state, action) => {
        state.loadingListEventsActivitiesNextFlow = false;
        state.errorListEventsActivitiesNextFlow = action.payload;
      })
      .addCase(UpdateEventsActivitiesNextFlowData.pending, (state, action) => {
        state.loadingUpdateEventsActivitiesNextFlow = true;
        state.UpdateEventsActivitiesNextFlow = action.payload;
        state.errorUpdateEventsActivitiesNextFlow = null;
      })
      .addCase(
        UpdateEventsActivitiesNextFlowData.fulfilled,
        (state, action) => {
          state.loadingUpdateEventsActivitiesNextFlow = false;
          state.UpdateEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateEventsActivitiesNextFlowData.rejected, (state, action) => {
        state.loadingUpdateEventsActivitiesNextFlow = false;
        state.errorUpdateOpportunitiesObtained = action.payload;
      })
      .addCase(ValidateEventsActivitiesNextFlow.pending, (state, action) => {
        state.loadingEventsActivitiesNextFlowValidate = true;
        state.EventsActivitiesNextFlowValidate = action.payload;
        state.errorEventsActivitiesNextFlowValidate = null;
      })
      .addCase(ValidateEventsActivitiesNextFlow.fulfilled, (state, action) => {
        state.loadingEventsActivitiesNextFlowValidate = false;
        state.EventsActivitiesNextFlowValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateEventsActivitiesNextFlow.rejected, (state, action) => {
        state.loadingEventsActivitiesNextFlowValidate = false;
        state.errorEventsActivitiesNextFlowValidate = action.payload;
      })
      .addCase(AddEventsActivitiesNextFlowData.pending, (state, action) => {
        state.loadingAddEventsActivitiesNextFlow = true;
        state.AddEventsActivitiesNextFlow = action.payload;
        state.errorAddEventsActivitiesNextFlow = null;
      })
      .addCase(AddEventsActivitiesNextFlowData.fulfilled, (state, action) => {
        state.loadingAddEventsActivitiesNextFlow = false;
        state.AddEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddEventsActivitiesNextFlowData.rejected, (state, action) => {
        state.loadingAddEventsActivitiesNextFlow = false;
        state.errorAddEventsActivitiesNextFlow = action.payload;
      })

      .addCase(
        GetSpecificRowNoteEventsActivitiesNextFlow.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteEventsActivitiesNextFlow = true;
          state.OneSpecificRowNoteEventsActivitiesNextFlow = action.payload;
          state.errorOneSpecificRowNoteEventsActivitiesNextFlow = null;
        }
      )
      .addCase(
        GetSpecificRowNoteEventsActivitiesNextFlow.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteEventsActivitiesNextFlow = false;
          state.OneSpecificRowNoteEventsActivitiesNextFlow = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteEventsActivitiesNextFlow.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteEventsActivitiesNextFlow = false;
          state.errorOneSpecificRowNoteEventsActivitiesNextFlow =
            action.payload;
        }
      );
  },
});
export const { restValidateEventsActivitiesNextFlow } =
  EventsActivitiesNextFlow.actions;
export default EventsActivitiesNextFlow.reducer;
